import React, { useState } from 'react';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import { LocalizationForm } from './LocalizationForm';
import { LocalizationTable } from './LocalizationTable';

export const LocalizationTab = ({
  projectId,
  localization,
  addLocalizationKeyValue,
  deleteLocalizationKeyValue,
  updateLocalizationKeyValue,
  setToggleActiveLang,
  deleteFlag,
  isReadOnly,
}) => {
  const [language, setLanguage] = useState(localization[0] ? localization[0].language : '');

  return (
    <>
      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
        <ParentCardNoCol title="Localization" icon="localization" bgColor="drapcode-violet">
          <LocalizationForm
            projectId={projectId}
            language={language}
            setLanguage={setLanguage}
            localization={localization}
            addLocalizationKeyValue={addLocalizationKeyValue}
            setToggleActiveLang={setToggleActiveLang}
            isReadOnly={isReadOnly}
          />
          <LocalizationTable
            projectId={projectId}
            localization={localization}
            language={language}
            deleteLocalizationKeyValue={deleteLocalizationKeyValue}
            updateLocalizationKeyValue={updateLocalizationKeyValue}
            deleteFlag={deleteFlag}
            isReadOnly={isReadOnly}
          />
        </ParentCardNoCol>
      </div>
    </>
  );
};
